import TechnologyList, { Technology } from '@components/TechnologyList/TechnologyList.component';
import {
  Box,
  Button,
  InputAdornment,
  styled,
  TextField,
  Typography,
  CircularProgress,
} from '@mui/material';
import { createFileRoute } from '@tanstack/react-router';
import { useQuery } from '@tanstack/react-query';
import axios from 'axios';
import SearchIcon from 'icons/Search.icon';
import ReactIcon from 'icons/Technologies/React.icon';
import AndroidIcon from 'icons/Technologies/Android.icon';
import { useState, useEffect } from 'react';
import NoData from 'icons/NoData.icon';
// import { useAuthStore } from 'store/authStore';

const StyledSearch = styled(TextField)({
  paddingTop: '34px',
  maxWidth: '720px',
  width: '100%',
  '& .MuiOutlinedInput-root': {
    borderRadius: '8px',
    backgroundColor: '#FFFFFF',
    '& fieldset': {
      borderColor: 'var(--Interviewer-Lightest-Black)',
      
    },
    '&:hover fieldset': {
      borderColor: 'var(--Interviewer-Lightest-Black)',
    },
    '&.Mui-focused fieldset': {
      borderColor: 'var(--Interviewer-Lightest-Black)',
    },
  },
});

const StyledButton = styled(Button)({
  padding: '6px 14px',
  borderRadius: '8px',
  background: 'var(--Lightest-Green)',
  fontWeight: 600,
  fontSize: '14px',
  lineHeight: '20px',
  color: 'var(--Interviewer-Green)',
});

interface TechnologyGroup {
  name: string;
  technologies: Technology[];
}

export const Route = createFileRoute('/(dashboard)/_dashboard/technologies')({
  component: RouteComponent,
});

function RouteComponent() {
  const [searchInput, setSearchInput] = useState('');
  const [debouncedSearch, setDebouncedSearch] = useState('');


  function DebugAuth() {
    // const state = useAuthStore();
    // return <pre>{state.roles}</pre>;
  }

  useEffect(() => {
    const timer = setTimeout(() => {
      setDebouncedSearch(searchInput);
    }, 800);

    return () => clearTimeout(timer);
  }, [searchInput]);

  const { data: apiData, isLoading, error } = useQuery({
    queryKey: ['technologies', debouncedSearch],
    queryFn: async () => {
      const token = localStorage.getItem('token');
      const response = await axios.get(`https://interviewer.runasp.net/api/technologies/main-organization${debouncedSearch ? `?searchTerm=${debouncedSearch}` : ''}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      return response.data;
    },
  });

  if (isLoading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
        <CircularProgress />
      </Box>
    );
  }

  if (error) {
    return (
      <NoData />
    );
  }

  return (
    <Box sx={{
      padding: {xs: '20px 16px', md: '125px 75px'}
    }}>
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            paddingBottom: '64px'
          }}
        >
          <Box sx={{display: 'flex', flexDirection: 'column', gap: '8px', alignItems: 'center'}}>
            <Typography variant="h1">Select Technology</Typography>
            <Typography variant="h4" sx={{ textAlign: 'center'}}>
              Select the category from the list or search for a specific technology
            </Typography>
          </Box>

          <StyledSearch
            value={searchInput}
            onChange={(e) => setSearchInput(e.target.value)}
            fullWidth
            type="search"
            slotProps={{
              input: {
                startAdornment: (
                  <InputAdornment position="start">
                    <SearchIcon />
                  </InputAdornment>
                ),
              },
            }}
            placeholder="Search for a technology"
          />

          {/* <Box sx={{ display: 'flex', gap: '16px', paddingTop: '16px' }}>
            <StyledButton>Mobile</StyledButton>
            <StyledButton>Backend</StyledButton>
            <StyledButton>Frontend</StyledButton>
          </Box> */}

          <DebugAuth />
        </Box>

        <Box sx={{ display: 'flex', flexDirection: 'column', gap: '64px' }}>
          {apiData.map((group: TechnologyGroup, index: number) => (
            <Box key={index} sx={{ 
              paddingBottom: '32px',
              borderBottom: index < apiData.length - 1 ? '1px solid var(--Light-Gray)' : 'none',
              '&:last-child': {
                borderBottom: 'none'
              }
            }}>
              <TechnologyList
                groupName={group.field}
                technologies={group.technologies.map((tech: Technology) => ({
                  ...tech,
                  icon:
                    tech.name.toLowerCase() === 'react'
                      ? <ReactIcon />
                      : tech.name.toLowerCase() === 'vue'
                        ? <AndroidIcon />
                        : null,
                }))}
              />
            </Box>
          ))}
        </Box>
    </Box>
  );
}

export default RouteComponent;
